module.exports = __webpack_public_path__ + "static/media/b6-fav.946dcd05.ico";